import React from "react";

import styles from "./Billing.module.scss";
import { BillingPaymentsList } from "../../BillingPaymentsList";
import { BillingHistoryList } from "../../BillingHistoryList";
import { getSelectedYear } from "../../../selectors";
import { useSelector } from "react-redux";
import { useGetBillingPaymentsQuery } from "../../../api/citizenApi";
import { ContentLoader } from "../../ContentLoader";
import { useTranslation } from "react-i18next";
import { Box } from "../../Box";
import { BillingStatusSummaryCard } from "../../BillingStatusSummaryCard";

export const Billing: React.FC<{}> = () => {
  const { t } = useTranslation();

  const selectedYear = useSelector(getSelectedYear);
  const { data, isFetching, isError } = useGetBillingPaymentsQuery(selectedYear);

  if (isFetching || data === undefined) return <ContentLoader />;

  if (isError) {
    return (
      <div className={styles.container}>
        <Box>{t("payments.errorLoading")}</Box>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <BillingStatusSummaryCard payments={data?.payments ?? []} amount={data?.unpaidAmount ?? 0} />
      <BillingPaymentsList payments={data?.payments ?? []} />
      <BillingHistoryList history={data?.history ?? []} />
    </div>
  );
};
